var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHappyLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "illustration styles_illustrationTablet__1DWOa",
    width: 406,
    height: 306,
    viewBox: "0 0 400 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "#282_happy_face_flatline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.85,150.43a4,4,0,0,1-2.23-.68C87.21,112.45,76.47,76.59,76,75.08a4,4,0,0,1,7.69-2.19c.1.33,10.62,34.72,63.36,70.22a4,4,0,0,1-2.24,7.32Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.44 145.75c-20.67 0-52.69-26.24-56.77-29.67a4 4 0 1 1 5.13 -6.08 223.5 223.5 0 0 0 23.67 16.9c15.32 9.35 27.21 13 32.61 9.9 11.95-6.77 11.28-34.31 10-44.35a4 4 0 1 1 7.94 -1 115.67 115.67 0 0 1 0.35 21.4c-1.3 15.85-6.13 26.25-14.36 30.91a17.1 17.1 0 0 1 -8.57 1.99z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.15,231.36a4,4,0,0,1-.07-8c12.17-.23,21.55-3.86,27.89-10.82,10.59-11.62,9.44-28.74,9.43-28.91a4,4,0,1,1,8-.6c.06.84,1.39,20.75-11.5,34.9-7.87,8.64-19.2,13.16-33.66,13.43Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.85,223.06a4,4,0,0,1-3.9-3.12c-6.63-29.32-47.61-30.27-48-30.28a4,4,0,0,1,.12-8,85,85,0,0,1,24.43,4.66c17.12,6.05,27.93,17.07,31.27,31.86a4,4,0,0,1-3,4.78A3.83,3.83,0,0,1,275.85,223.06Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.89,
    cy: 272.74,
    rx: 48.03,
    ry: 7.61,
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.24,
    cy: 138.58,
    r: 65.45,
    fill: "#e32b2b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.24,73.13a65.45,65.45,0,1,1-65.44,65.45,65.45,65.45,0,0,1,65.44-65.45m0-1a66.48,66.48,0,1,0,66.48,66.48A66.56,66.56,0,0,0,197.24,72.1Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.9 123.36a1.5 1.5 0 0 1 -1.5 -1.5c0-6.52-2.23-10.84-3.7-10.84s-3.7 4.32-3.7 10.84a1.5 1.5 0 1 1 -3 0c0-6.71 2.35-13.84 6.7-13.84s6.7 7.13 6.7 13.84a1.5 1.5 0 0 1 -1.5 1.5z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,123.36a1.5,1.5,0,0,1-1.5-1.5c0-6.52-2.23-10.84-3.7-10.84s-3.7,4.32-3.7,10.84a1.5,1.5,0,0,1-3,0c0-6.71,2.35-13.84,6.7-13.84s6.7,7.13,6.7,13.84A1.5,1.5,0,0,1,224,123.36Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.7 152.29c0 15.26-16.32 27.62-36.46 27.62s-36.46-12.36-36.46-27.62z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.19,106.49c-4.45-2.69-7.2-12.69-6.46-18.18s3.44-4.71,6.41-5.23c-.31-2.25-.55-4.78.87-6.55a7.13,7.13,0,0,1,2.89-2,26.12,26.12,0,0,1,19.45-.4,7.55,7.55,0,0,1,3.16,2,7.74,7.74,0,0,1,1.39,3.28c2.57,11.16-2.93,18.42-4.23,28.85l-12.58-.88c-2.81-.19-8.32.55-10.79-.85A.41.41,0,0,1,292.19,106.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.67,108.8h0l-12.58-.87c-.8-.06-1.87,0-3,0-2.87.07-6.13.14-8-.91l-.13-.07h0c-4.87-3-7.42-13.37-6.71-18.69.68-5,3-5.24,5.45-5.5l.9-.1c-.29-2.32-.37-4.67,1.05-6.45a7.59,7.59,0,0,1,3.09-2.09,26.5,26.5,0,0,1,19.84-.41,7.94,7.94,0,0,1,3.37,2.13,8.2,8.2,0,0,1,1.49,3.5c1.68,7.29,0,12.88-1.79,18.8a60.66,60.66,0,0,0-2.43,10.22A.51.51,0,0,1,315.67,108.8Zm-13.83-1.94c.46,0,.9,0,1.28,0l12.1.84a63.3,63.3,0,0,1,2.4-9.91c1.75-5.78,3.4-11.24,1.77-18.27a7.25,7.25,0,0,0-1.28-3.07,7.09,7.09,0,0,0-2.94-1.83,25.49,25.49,0,0,0-19.06.39,7,7,0,0,0-2.7,1.8c-1.27,1.58-1.07,3.91-.76,6.16a.51.51,0,0,1-.42.58c-.5.08-1,.14-1.46.19-2.3.24-4,.41-4.53,4.6-.76,5.62,2.12,15.19,6.21,17.67l.1.06c1.62.92,4.86.84,7.47.78Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-1 .03 -.03 -1 612.26 204.65)",
    x: 287.16,
    y: 102.97,
    width: 34.67,
    height: 8.51,
    rx: 3.99,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.15,112.42a4.51,4.51,0,0,1-4.49-4.36l0-.53a4.51,4.51,0,0,1,4.36-4.65l26.68-.85a4.48,4.48,0,0,1,3.23,1.21,4.53,4.53,0,0,1,1.42,3.14v.54a4.49,4.49,0,0,1-4.35,4.64l-26.69.86Zm-.12-8.51a3.48,3.48,0,0,0-3.36,3.58l0,.54a3.47,3.47,0,0,0,3.58,3.36l26.69-.86a3.45,3.45,0,0,0,3.35-3.58v-.53a3.48,3.48,0,0,0-3.58-3.36l-26.69.85Zm0-.51h0Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.82,
    cy: 135.37,
    rx: 7.96,
    ry: 5.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.67,
    cy: 135.37,
    rx: 7.96,
    ry: 5.06,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.14 83.08s17.21-2.43 15.47 2.31-14.07 7.27-14.07 7.27 11-3 13.58 5.27",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.12,98.44a.51.51,0,0,1-.49-.36c-1-3.2-3.45-5-7.29-5.37a17.7,17.7,0,0,0-4.9.28l-.8.18a.52.52,0,0,1-.24-1l.66-.14c2.5-.59,11.67-3,13.07-6.81a.89.89,0,0,0-.1-1c-1.45-1.79-9.86-1.35-14.82-.65a.51.51,0,1,1-.14-1c1.37-.2,13.47-1.81,15.76,1a1.94,1.94,0,0,1,.27,2c-1,2.82-5.39,4.85-9.06,6.1,3.33.23,7.16,1.55,8.57,6.1a.51.51,0,0,1-.33.65A.47.47,0,0,1,307.12,98.44Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.07,88c2.79-4.39.8-14.57-2.31-19.16S94.57,66.13,91.68,67C91,64.83,90.05,62.46,88,61.5a7.25,7.25,0,0,0-3.46-.45,26.11,26.11,0,0,0-17.59,8.3A7.47,7.47,0,0,0,65,72.53a7.69,7.69,0,0,0,.22,3.56C67.88,87.22,76,91.27,81.85,100l10.87-6.38c2.43-1.43,7.69-3.22,9.28-5.57Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.85,100.55a.51.51,0,0,1-.43-.23,60.71,60.71,0,0,0-6.73-8.07c-4.24-4.51-8.23-8.76-10-16a8.24,8.24,0,0,1-.22-3.79A8,8,0,0,1,66.56,69,26.55,26.55,0,0,1,84.5,60.53a7.85,7.85,0,0,1,3.7.5c2.07,1,3,3.11,3.81,5.31l.85-.31c2.32-.86,4.5-1.68,7.33,2.49,3,4.45,5.36,14.92,2.32,19.72h0l-.08.13c-1.2,1.77-4.15,3.15-6.76,4.38-1,.48-2,.93-2.69,1.34l-10.87,6.39A.48.48,0,0,1,81.85,100.55Zm3.52-39-.81,0A25.55,25.55,0,0,0,67.32,69.7a7.05,7.05,0,0,0-1.82,3A7.38,7.38,0,0,0,65.72,76c1.68,7,5.58,11.17,9.72,15.57A62.77,62.77,0,0,1,82,99.34L92.46,93.2c.74-.43,1.73-.9,2.78-1.39,2.36-1.11,5.29-2.48,6.34-4l.06-.1h0c2.56-4,.87-13.9-2.31-18.59C97,65.6,95.4,66.19,93.23,67c-.45.17-.92.34-1.4.49a.52.52,0,0,1-.64-.33C90.47,65,89.61,62.82,87.77,62A5.78,5.78,0,0,0,85.37,61.54Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "translate(-30.89 46.61) rotate(-24.61)",
    x: 74.04,
    y: 89.85,
    width: 34.67,
    height: 8.51,
    rx: 3.99,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.36,104.41a4.5,4.5,0,0,1-1.57-.29,4.44,4.44,0,0,1-2.53-2.34l-.22-.49a4.51,4.51,0,0,1,2.22-6L101.53,84.2a4.52,4.52,0,0,1,6,2.22l.22.49a4.51,4.51,0,0,1-2.22,6L81.23,104A4.54,4.54,0,0,1,79.36,104.41Zm24-19.58a3.52,3.52,0,0,0-1.44.31h0L77.69,96.26a3.47,3.47,0,0,0-1.71,4.6l.22.49a3.47,3.47,0,0,0,4.6,1.71l24.28-11.12a3.48,3.48,0,0,0,1.7-4.6l-.22-.49A3.47,3.47,0,0,0,103.4,84.83Zm-1.65-.16h0Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.68,67s-16.48,5.49-12.82,9,15.84.24,15.84.24S83.51,78.4,84.89,87",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.89,87.46a.52.52,0,0,1-.51-.43c-.76-4.71,2.08-7.6,5-9.28-3.84.51-8.65.63-10.83-1.43a1.94,1.94,0,0,1-.65-1.89c.79-3.56,12.35-7.5,13.66-7.94a.52.52,0,0,1,.65.33.51.51,0,0,1-.32.65c-4.76,1.58-12.48,4.93-13,7.18a.9.9,0,0,0,.35.92c3,2.8,12.23.86,14.72.27.4-.11.64-.16.66-.16a.52.52,0,0,1,.6.39.5.5,0,0,1-.37.61l-.79.2a17.79,17.79,0,0,0-4.51,1.93c-3.28,2-4.67,4.74-4.13,8.06a.52.52,0,0,1-.43.59Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.33 196.81s-18.21 4.27-22.39 20.68l24 33.07 32.55-45.42-24 8.21z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.91,251.08a.54.54,0,0,1-.42-.21l-24-33.08a.51.51,0,0,1-.08-.43c4.21-16.52,22.59-21,22.78-21.05a.5.5,0,0,1,.55.23l9.88,16.19,23.65-8.08a.51.51,0,0,1,.58.79l-32.55,45.42C282.23,251,282.07,251.13,281.91,251.08Zm-23.41-33.7,23.41,32.3,31.19-43.53-22.51,7.69a.51.51,0,0,1-.61-.22l-9.89-16.21C277.56,198.11,262.33,202.91,258.5,217.38Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.24 251.79c-8.88-7 0.88-18 10.2-30.44 6.7-8.9 19.12-19.79 25.13-15.08 6.91 5.42-24.78 53.8-35.33 45.52z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.08,253.26a5,5,0,0,1-3.16-1.06h0c-8.53-6.69-.62-17.06,7.75-28L293,221c5.47-7.26,14.35-15.48,20.94-16.34a6.34,6.34,0,0,1,4.92,1.17c1,.8,1.38,2.33,1.06,4.55-1.48,10.45-18.9,37.41-30.69,42.15A8.62,8.62,0,0,1,286.08,253.26Zm-2.52-1.87c1.32,1,3.11,1.11,5.32.22,10.57-4.25,28.49-30.38,30.05-41.34.18-1.25.21-2.9-.67-3.59a5.35,5.35,0,0,0-4.15-1c-6,.79-14.75,8.62-20.26,15.94l-2.36,3.12c-8.4,11-15.66,20.54-7.93,26.61Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.22 238.22l-3.6-25a134.55 134.55 0 0 1 -32.62 4.5s-5.79 39.33-3.14 39.46 12.4-16.74 12.4-16.74 8.28 3.56 26.96-2.22z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.85,257.69h0a.82.82,0,0,1-.6-.32c-2.1-2.54,2.34-33.54,3.25-39.72a.5.5,0,0,1,.5-.44,135.55,135.55,0,0,0,32.51-4.46.5.5,0,0,1,.43.06.49.49,0,0,1,.23.36l3.6,25a.53.53,0,0,1-.36.57c-16.52,5.13-25,3-26.91,2.36C102.92,245.46,95.56,257.69,92.85,257.69Zm3.56-39.46c-2.55,17.48-4.6,36.6-3.45,38.43,1.6-.28,7.21-8.49,11.82-16.47a.52.52,0,0,1,.65-.22c.09,0,8.29,3.37,26.21-2.11l-3.45-24A139.3,139.3,0,0,1,96.41,218.23Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.62 213.24s-3.47 3.39-3.47 14.12c0 5.79 4 13.31 7.07 10.86s4.59-24.99-3.6-24.98z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,239.22a2.78,2.78,0,0,1-1.19-.29c-2.64-1.27-5.15-6.89-5.15-11.57,0-10.82,3.48-14.34,3.63-14.49a.52.52,0,0,1,.37-.14c2.35,0,4.18,1.67,5.3,4.83,2.31,6.56,1.1,19.06-1.39,21.06A2.45,2.45,0,0,1,131,239.22Zm-2.12-25.46c-.62.77-3.18,4.49-3.18,13.6,0,4.26,2.26,9.53,4.56,10.64a1.45,1.45,0,0,0,1.66-.18c1.78-1.43,3.45-13.15,1.06-19.92C132,215.26,130.64,213.87,128.85,213.76Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.91,
    x2: 249.92,
    y1: 44.32,
    y2: 66.98,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.92,67.5a.52.52,0,0,1-.37-.88l22-22.66a.51.51,0,0,1,.73,0,.52.52,0,0,1,0,.73l-22,22.66A.5.5,0,0,1,249.92,67.5Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.45,
    x2: 201.32,
    y1: 55.65,
    y2: 27.99,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.45,56.17a.52.52,0,0,1-.51-.5L200.8,28a.52.52,0,0,1,.5-.54.53.53,0,0,1,.53.5L203,55.63a.53.53,0,0,1-.5.54Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.8,
    x2: 111.5,
    y1: 75.86,
    y2: 46.19,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.8,76.37a.51.51,0,0,1-.38-.16l-27.3-29.67a.52.52,0,1,1,.76-.7l27.3,29.67a.52.52,0,0,1,0,.73A.51.51,0,0,1,138.8,76.37Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.5,
    x2: 44.29,
    y1: 157.75,
    y2: 162.16,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.28,162.67a.52.52,0,0,1,0-1l67.21-4.4a.52.52,0,1,1,.07,1l-67.21,4.4Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.48,
    x2: 79.88,
    y1: 192.42,
    y2: 204.03,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.88,204.54a.5.5,0,0,1-.47-.31.52.52,0,0,1,.27-.68l27.6-11.61a.52.52,0,0,1,.4.95L80.08,204.5A.45.45,0,0,1,79.88,204.54Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.55,
    x2: 363.71,
    y1: 158.9,
    y2: 145.68,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.55,159.42a.51.51,0,0,1-.5-.42.51.51,0,0,1,.41-.6l68.16-13.22a.5.5,0,0,1,.6.4.52.52,0,0,1-.41.61l-68.16,13.22Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.65,
    x2: 342.3,
    y1: 185.66,
    y2: 196.81,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.3,197.33l-.13,0-42.65-11.15a.52.52,0,1,1,.26-1l42.65,11.15a.52.52,0,0,1-.13,1Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.84,
    x2: 160.78,
    y1: 55.65,
    y2: 44.32,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.84,56.17a.5.5,0,0,1-.48-.35L160.3,44.49a.51.51,0,0,1,.31-.66.53.53,0,0,1,.66.31l4.06,11.34a.52.52,0,0,1-.31.66Z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.68,
    x2: 73.34,
    y1: 130.31,
    y2: 121.86,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.68,130.83a.48.48,0,0,1-.2,0l-20.34-8.46a.52.52,0,0,1-.28-.67.53.53,0,0,1,.68-.28l20.34,8.46a.52.52,0,0,1,.28.67A.53.53,0,0,1,93.68,130.83Z",
    fill: "#d1d3d4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyLight);
export default __webpack_public_path__ + "static/media/happy-light.123fb8ff76f11b3bcabbc5de891476da.svg";
export { ForwardRef as ReactComponent };